// @flow
import React, { useState, useRef, useCallback } from 'react'
import classnames from 'classnames'
import {
  EditorState,
  // convertToRaw,
  convertFromRaw,
  ContentState,
} from 'draft-js'

import createEmojiPlugin from '@draft-js-plugins/emoji'
import createHashtagPlugin from '@draft-js-plugins/hashtag'
import createLinkifyPlugin from '@draft-js-plugins/linkify'
import Editor from '@draft-js-plugins/editor'
// import createMentionPlugin, { defaultSuggestionsFilter } from '@draft-js-plugins/mention'

import { useRouter } from 'next/router'
import styles from './editor.module.scss'
import hashtagStyles from './hashtag.module.scss'
// import mentionsStyles from './mention.scss'

// const HASHTAG_REGEX = /[#＃][Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-]+/gm
// eslint-disable-next-line no-useless-escape
const HASHTAG_REGEX = /(#[^\u2000-\u206F\u2E00-\u2E7F\s\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]*)/gm

// @TODO mentions must be request
// const suggestions = [
//   {
//     id: 'adfdar',
//     username: 'mat',
//     name: 'Matthew Russell',
//     link: 'https://twitter.com/mrussell247',
//     avatar: 'https://pbs.twimg.com/profile_images/517863945/mattsailing_400x400.jpg',
//   },
//   {
//     id: 'fdagfae',
//     username: 'julian',
//     name: 'Julian Krispel-Samsel',
//     link: 'https://twitter.com/juliandoesstuff',
//     avatar: 'https://avatars2.githubusercontent.com/u/1188186?v=3&s=400',
//   },
// ]

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  about: any
  readOnly?: boolean
  placeholder?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (descTxt: string, hashtags: any) => void
}

// type States = {
// }

const AboutEdit = ({
  about,
  readOnly = false,
  placeholder = 'Please input text...',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange = (f: any) => f,
}: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let initState: any
  if (!about) {
    initState = EditorState.createEmpty()
  }
  else if (typeof about !== 'string') {
    initState = EditorState.createWithContent(convertFromRaw(about))
  }
  else {
    initState = EditorState.createWithContent(
      ContentState.createFromText(about),
    )
  }

  const router = useRouter()
  const [ editorState, setEditorState ] = useState(initState)
  const [ isFocus, setFocus ] = useState(false)
  const editorRef = useRef(null)
  const linkifyPlugin = useRef(createLinkifyPlugin())
  const emojiPlugin = useRef(createEmojiPlugin())
  const hashtagPlugin = useRef(
    createHashtagPlugin({
      theme: hashtagStyles,
    }),
  )
  // const mentionPlugin = useRef(createLinkifyPlugin())

  const plugins = [
    linkifyPlugin.current,
    emojiPlugin.current,
    hashtagPlugin.current,
    // mentionPlugin,
  ]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChangeText = (state: any) => {
    const contentState = state.getCurrentContent()
    const plainText = contentState.getPlainText()

    setEditorState(state)

    // extract hashtags
    const hashtags = (plainText.match(HASHTAG_REGEX) || [])
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((tag) => tag.replace(/^#/, ''))

    // estract mentions
    // const mentions = Object.keys(raw.entityMap)
    //   .map(k => raw.entityMap[k])
    //   .filter(content => content.type === 'mention')
    //   .map(content => content.data.mention)
    // console.log(mentions)

    onChange(plainText, hashtags)
  }

  // onSearchChange = ({ value }) => {
  //   this.setState({
  //     suggestions: defaultSuggestionsFilter(value, suggestions),
  //   })
  // }

  // const onAddMention = () => {
  //   // get the mention object selected
  // }

  const onFocus = () => setFocus(true)
  const onBlur = () => setFocus(false)

  const onTagPress: React.MouseEventHandler<HTMLDivElement> = useCallback(({ target }) => {
    if (!readOnly) {
      return
    }
    if (target instanceof HTMLElement) {
      const hashtag = target?.innerText?.match(HASHTAG_REGEX)
      if (hashtag?.length === 1) {
        router.push(`/tag/${hashtag[0].replace(/^#/, '')}`)
      }
    }
  }, [ router, readOnly ])

  // const { MentionSuggestions } = mentionPlugin.current
  const { EmojiSuggestions } = emojiPlugin.current

  return (
    <div
      className={classnames(styles.editor, {
        [styles.focus]: isFocus,
        [styles.readOnly]: readOnly,
      })}
      onClick={onTagPress}
    >
      <Editor
        ref={editorRef}
        editorState={editorState}
        onChange={onChangeText}
        plugins={plugins}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
        stripPastedStyles
      />
      {/* <MentionSuggestions
        onSearchChange={this.onSearchChange}
        suggestions={suggestions}
        onAddMention={this.onAddMention}
      /> */}
      <EmojiSuggestions />
    </div>
  )
}

export default AboutEdit
